<template>
  <v-navigation-drawer
    :value="value"
    right
    app
    persistent
    fixed
    clipped
    @input="$emit('input', $event)"
  >
    <v-list nav shaped dense>
      <v-list-item
        v-for="session in openedSessionList"
        :key="session.id"
        :to="`/animation/session/${session.id}`"
        active-class="active-session"
        color="accent"
      >
        <v-list-item-content>
          <v-list-item-title v-text="session.name" />
        </v-list-item-content>
        <v-list-item-icon>
          <ag-confirm-dialog
            :title="$t('general.confirmation')"
            :message="$t('animation.message.closeSession')"
            :cancel-label="$t('general.cancel')"
            :confirm-label="$t('general.remove')"
            validation-btn-color="error"
            @confirm="closeSession(session.id)"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                style="margin-top: -3px;"
                icon
                text
                small
                v-bind="attrs"
                @click.stop.prevent="on.click"
              >
                <v-icon>mdi-close-circle-outline</v-icon>
              </v-btn>
            </template>
          </ag-confirm-dialog>
        </v-list-item-icon>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <div class="pa-2">
        <v-btn
          block
          color="accent"
          outlined
          @click="$emit('add-sessions')"
          v-text="$t('animation.menu.right.addsession')"
        />
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AgConfirmDialog from 'src/components/common/AgConfirmDialog'

export default {
  name: 'RightSessionMenu',
  components: {
    AgConfirmDialog,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('animation', {
      openedSessionList: 'openedSessionList',
    }),
  },
  methods: {
    ...mapActions('animation', {
      closeSession: 'closeSession',
    }),
  },
}
</script>

<style lang="scss" scoped>
  .active-session {
    &::before {
      opacity: 1;
    }

    &:hover::before {
      opacity: 0.8;
    }

    .v-list-item__title,
    .v-icon
    {
      color: white;
      z-index: 1;
    }
  }
</style>
